interface Category {
  id: number
  title: string
  code: string
  color: string
  bg_color: string
}

export const CATEGORY: Category[] = [
  {
    id: 1,
    title: "文章",
    code: "document",
    color: "#c61616",
    bg_color: "#ECD6D4",
  },
  {
    id: 2,
    title: "コミュニケーション",
    code: "communication",
    color: "#0d9554",
    bg_color: "#DCE8DF",
  },
  {
    id: 3,
    title: "クリエイティブ",
    code: "creative",
    color: "#d89516",
    bg_color: "#F3EAD9",
  },
  {
    id: 4,
    title: "インターネット",
    code: "internet",
    color: "#44b5f4",
    bg_color: "#E3F0FB",
  },
  {
    id: 5,
    title: "経理",
    code: "accounting",
    color: "#6f4eaa",
    bg_color: "#E0D6F4",
  },
  {
    id: 6,
    title: "営業・マーケティング",
    code: "marketing",
    color: "#446bf4",
    bg_color: "#DCE2F9",
  },
  {
    id: 7,
    title: "その他",
    code: "other",
    color: "#8d6009",
    bg_color: "#E6DFD4",
  },
]

export default CATEGORY
